module.exports = __webpack_public_path__ + "img/c32a7e4.png";